/**
 * The admin SPA lives on console.{baseDomain}. The platform infrastructure
 * tenant has slug "platform" (matching the host label 1:1) and is flagged
 * is_infrastructure=true in the database. The backend's
 * TenantIdentification middleware resolves the tenant from the first
 * subdomain component, so "console.{baseDomain}" resolves directly — no
 * explicit slug override is needed for the host-based path.
 *
 * This constant remains for tenant-scoped admin-API calls that must pass
 * X-Tenant-Slug explicitly (legacy /api/admin/v1 routes). It is removed
 * entirely in Phase 3 when the frontend splits into platform/tenant
 * bundles and each bundle reads its scope from routing, not a constant.
 *
 * Overridable via VITE_PUREID_PLATFORM_TENANT_SLUG for deployments that
 * seed the platform tenant under a different slug.
 */
export const PLATFORM_TENANT_SLUG =
  (import.meta.env.VITE_PUREID_PLATFORM_TENANT_SLUG as string | undefined) ??
  "platform";
